class BDTestimonialVideo extends HTMLElement {
  constructor() {
    super();
    this.video = null;

    this.playBtn = null;
    this.playIcon = null;
    this.pauseIcon = null;

    this.volumeBtn = null;
    this.muteIcon = null;
    this.volumeOnIcon = null;

    this.isUserControlling = false; // ⭐ NEW
  }

  connectedCallback() {
    this.video = this.querySelector('video');

    this.playBtn = this.querySelector('[data-play]');
    this.playIcon = this.querySelector('[data-play-now]');
    this.pauseIcon = this.querySelector('[data-pause]');

    this.volumeBtn = this.querySelector('[data-volume]');
    this.muteIcon = this.querySelector('[data-mute]');
    this.volumeOnIcon = this.querySelector('[data-volume-on]');

    if (!this.video) return;

    this.video.style.objectFit = 'cover';
    this.video.style.webkitObjectFit = 'cover';

    this.initVisibilityObserver();
    this.bindEvents();

  this.addEventListener('click', (e) => {
  if (e.target.closest('[data-play]')) return;          // keep your rule
  if (!this.closest('.slide.is-center')) return;        // only center slide

  this.isUserControlling = true;

  this.video.paused
    ? this.playVideo()
    : this.pauseVideo();
});
  }

  bindEvents() {
    this.playBtn?.addEventListener('click', () => {
      this.isUserControlling = true; // ⭐ user override

      if (this.video.paused) {
        this.playVideo();
      } else {
        this.pauseVideo();
      }
    });

    this.volumeBtn?.addEventListener('click', () => {
      this.isUserControlling = true; // ⭐ user override

      this.video.muted = !this.video.muted;
      this.updateVolumeState(!this.video.muted);
    });
  }

  updatePlayState(isPlaying) {
    if (isPlaying) {
      this.playIcon?.classList.remove('active');
      this.pauseIcon?.classList.add('active');
    } else {
      this.pauseIcon?.classList.remove('active');
      this.playIcon?.classList.add('active');
    }
  }

  updateVolumeState(isVolumeOn) {
    if (isVolumeOn) {
      this.muteIcon?.classList.remove('active');
      this.volumeOnIcon?.classList.add('active');
    } else {
      this.volumeOnIcon?.classList.remove('active');
      this.muteIcon?.classList.add('active');
    }
  }

  playVideo() {
    this.video.play().catch(() => {});
    this.updatePlayState(true);
  }

  pauseVideo() {
    this.video.pause();
    this.updatePlayState(false);
  }

  muteVideo() {
    this.video.muted = true;
    this.updateVolumeState(false);
  }

  unmuteVideo() {
    this.video.muted = false;
    this.updateVolumeState(true);
  }

  initVisibilityObserver() {
    if (!('IntersectionObserver' in window) || !this.video) return;

    this._observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            this.pauseVideo();
            this.muteVideo();
          }
        });
      },
      { threshold: 0.15 },
    );

    this._observer.observe(this);
  }
}

customElements.define('bd-testimonial-video', BDTestimonialVideo);

customElements.whenDefined('bd-testimonial-video').then(() => {
  // Inside your customElements.whenDefined('bd-testimonial-video').then(...) block:
document.addEventListener('embla-ready', (event) => {
  const sliderEl = event.target;
  const embla = sliderEl.embla;
  if (!embla) return;

  let hasInteracted = false;

  // Add click handler for slides
  sliderEl.addEventListener('click', (e) => {
    console.log('Click event triggered on slider!');

    const clickedSlide = e.target.closest('.slide');
    console.log('Clicked slide element:', clickedSlide);

    if (!clickedSlide) {
      console.log('No slide found for this click.');
      return;
    }

    const slideIndex = Array.from(embla.slideNodes()).indexOf(clickedSlide);
    console.log('Clicked slide index:', slideIndex);
    console.log('Current selected snap:', embla.selectedScrollSnap());

    if (slideIndex !== embla.selectedScrollSnap()) {
      console.log(`Scrolling to slide index: ${slideIndex}`);
      embla.scrollTo(slideIndex);
      hasInteracted = true;
    } else {
      console.log('Clicked slide is already centered.');
    }
  });

  // Rest of your logic for updating videos
  function updateVideos() {
    console.log('updateVideos called');
    const slides = embla.slideNodes();
    const scrollProgress = embla.scrollProgress();
    const snaps = embla.scrollSnapList();

    let centerIndex = 0;
    let smallestDiff = Infinity;

    snaps.forEach((snap, index) => {
      const diff = Math.abs(snap - scrollProgress);
      if (diff < smallestDiff) {
        smallestDiff = diff;
        centerIndex = index;
      }
    });

    console.log('Calculated center index:', centerIndex);

    slides.forEach((slide, i) => {
      const videoEl = slide.querySelector('bd-testimonial-video');
      if (!videoEl) return;

      console.log(`Slide ${i} video element:`, videoEl);

      if (videoEl.isUserControlling) {
        console.log(`Slide ${i} is user-controlled, skipping.`);
        return;
      }
      if (!hasInteracted) {
        console.log(`Slide ${i} not interacted yet, pausing and muting.`);
        videoEl.pauseVideo();
        videoEl.muteVideo();
        return;
      }

      if (i === centerIndex) {
        console.log(`Playing video for center slide ${i}`);
        videoEl.playVideo();
        videoEl.unmuteVideo();
      } else {
        console.log(`Pausing and muting video for slide ${i}`);
        videoEl.pauseVideo();
        videoEl.muteVideo();
      }
    });
  }

  // Listen for Embla events
  embla.on('scroll', () => { console.log('Scroll event'); markInteraction(); resetUserControl(); updateVideos(); });
  embla.on('select', () => { console.log('Select event'); markInteraction(); updateVideos(); });
  embla.on('pointerUp', () => { console.log('PointerUp event'); markInteraction(); updateVideos(); });
  embla.on('settle', () => { console.log('Settle event'); markInteraction(); updateVideos(); });

  function markInteraction() { hasInteracted = true; }
  function resetUserControl() {
    sliderEl.querySelectorAll('bd-testimonial-video')
      .forEach((v) => (v.isUserControlling = false));
  }

  updateVideos();
});
});
